import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { getPermission } from './permission'

Vue.use(Router)

const routers = [
  {
    path: '/',
    name: 'Home',
    component: (resolve) => require(['./views/home/HomeOverview.vue'], resolve),
    beforeEnter: (to, from, next) => {
      if (to.query.init) {
        store.state.client.isNewClient = true
      }
      next()
    }
  },
  {
    path: '/app-marketplace',
    name: 'App Marketplace',
    component: { template: '<router-view></router-view>' },
    children: [
      {
        path: '',
        name: 'App Marketplace',
        meta: {
          productLine: 'software_app'
        },
        component: (resolve) => require(['./views/market/index.vue'], resolve)
      },
      {
        path: ':id',
        name: 'App Marketplace Detail',
        component: (resolve) => require(['./views/market/AppPlanDetail.vue'], resolve)
      }
    ]
  },
  {
    path: '/affiliate',
    name: 'Affiliate',
    meta: {
      title: 'menu.affiliate[1]',
      permission: ['menu.affiliate']
    },
    component: (resolve) => require(['./views/affiliate/index.vue'], resolve)
  },
  {
    path: '/affiliate',
    name: 'Affiliate',
    meta: {
      title: 'menu.affiliate[1]',
      permission: ['menu.affiliate']
    },
    component: (resolve) => require(['./views/affiliate/index.vue'], resolve)
  },
  {
    path: '/document',
    name: 'Document',
    meta: {
      title: 'menu.doc[1]'
    },
    component: (resolve) => require(['./views/document/Document.vue'], resolve)
  },
  // 旧 /ordering/* 过渡重定向，兼容历史链接与书
  { path: '/ordering', redirect: '/' },
  { path: '/ordering/app', redirect: '/applications/ordering' },
  { path: '/ordering/vps', redirect: '/myvps/ordering' },
  { path: '/ordering/gpu', redirect: '/gpu-servers/ordering' },
  { path: '/ordering/dedicated', redirect: '/dedicated-servers/ordering' },
  { path: '/ordering/ssl', redirect: '/ssl/ordering' },
  { path: '/ordering/domain', redirect: '/domain/ordering' },
  { path: '/ordering/k8s', redirect: '/k8s-servers/ordering' },
  { path: '/ordering/software-app', redirect: '/app-marketplace' },
  { path: '/ordering/software-app/:id', redirect: '/app-marketplace/:id' },
  {
    path: '/myvps',
    name: 'VM',
    meta: {
      title: 'menu.vps[1]',
      i18n_text: 'menu.vps[0]',
      permission: ['menu.vps']
    },
    component: (resolve) => require(['./views/myvps/index.vue'], resolve)
  },
  // 与部署列表平级，未登录可浏览下单页
  {
    path: '/myvps/ordering',
    name: 'VPS Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.vps[0]',
      permission: ['menu.products.vps'],
      planCategory: 'VPS',
      planType: 'VM',
      productType: 'vps',
      productLine: 'vps',
      planTitleKey: 'menu.vps[0]'
    },
    component: (resolve) => require(['./views/ordering/PlanOrdering.vue'], resolve)
  },
  {
    path: '/myvps/:appId',
    name: 'VPS detail',
    meta: {
      permission: ['menu.vps']
    },
    redirect: '/myvps/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/myvps/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/myvps/:appId/networking',
        name: 'Networking',
        component: (resolve) => require(['./views/applications/networking/index.vue'], resolve)
      },

      {
        path: '/myvps/:appId/server-manage',
        name: 'ServerManagement',
        component: (resolve) => require(['./views/applications/servermanage/index.vue'], resolve)
      },
      {
        path: '/myvps/:appId/service-info',
        name: 'ServiceInfo',
        component: (resolve) => require(['./views/applications/serviceInfo/index.vue'], resolve)
      },
      {
        path: '/myvps/:appId/events',
        name: 'Event',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      }
    ]
  },
  {
    path: '/emails',
    name: 'Email Announcement',
    meta: {
      title: 'menu.emails[0]'
    },
    component: (resolve) => require(['./views/emails/index.vue'], resolve)
  },
  {
    path: '/dns',
    name: 'dns',
    meta: {
      title: 'menu.dns[1]'
    },
    component: (resolve) => require(['./views/dns/index.vue'], resolve)
  },
  {
    path: '/ticket',
    name: 'ticket',
    meta: {
      title: 'menu.tickets[1]'
    },
    component: (resolve) => require(['./views/tickets/TicketList.vue'], resolve)
  },
  {
    path: '/ticket/:tid',
    name: 'ticket-details',
    meta: {
      title: 'menu.ticket_detail[0]'
    },
    component: (resolve) => require(['./views/tickets/TicketDetails.vue'], resolve)
  },
  {
    path: '/applications',
    name: 'APP',
    meta: {
      title: 'menu.apps[1]',
      i18n_text: 'menu.apps[0]',
      permission: ['menu.apps']
    },
    component: (resolve) => require(['./views/applications/Applications.vue'], resolve)
  },
  // 与部署列表平级，不挂 children，避免未登录浏览时进入鉴权列表页
  {
    path: '/applications/ordering',
    name: 'App Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.app[0]',
      permission: ['menu.products.app'],
      productLine: 'app'
    },
    component: (resolve) => require(['./views/applications/Ordering.vue'], resolve)
  },

  {
    path: '/domain',
    name: 'Domain',
    meta: {
      title: 'menu.domain[0]',
      i18n_text: 'menu.domain[0]',
      permission: ['menu.domain']
    },
    component: (resolve) => require(['./views/domain/index.vue'], resolve)
  },
  // 与部署列表平级，未登录可浏览下单页
  {
    path: '/domain/ordering',
    name: 'Domain Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.domain[0]',
      permission: ['menu.products.domain'],
      productLine: 'domain'
    },
    component: (resolve) => require(['./views/domain/Ordering.vue'], resolve)
  },
  {
    path: '/domain/:appId',
    name: 'Domain',
    meta: {
      permission: ['menu.domain']
    },
    redirect: '/domain/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/domain/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/domain/:appId/dns',
        name: 'DNSManagement',
        component: (resolve) => require(['./views/applications/DNSManagement/index.vue'], resolve)
      },

      {
        path: '/domain/:appId/events',
        name: 'Event',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      }
    ]
  },
  {
    path: '/ssl',
    name: 'SSL',
    meta: {
      title: 'menu.ssl[0]',
      i18n_text: 'menu.ssl[0]',
      permission: ['menu.ssl']
    },
    component: (resolve) => require(['./views/sslServer/SSL.vue'], resolve)
  },
  // 与部署列表平级，未登录可浏览下单页
  {
    path: '/ssl/ordering',
    name: 'SSL Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.ssl[0]',
      permission: ['menu.products.ssl'],
      productLine: 'ssl'
    },
    component: (resolve) => require(['./views/sslServer/Ordering.vue'], resolve)
  },
  {
    path: '/ssl/:appId',
    name: 'SSL Servers',
    meta: {
      permission: ['menu.ssl']
    },
    redirect: '/ssl/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/ssl/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/ssl/:appId/events',
        name: 'Event',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      }
    ]
  },
  {
    path: '/applications/:appId',
    name: 'AppDetail',
    redirect: '/applications/:appId/overview',
    meta: {
      permission: ['menu.apps']
    },
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/applications/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/file-manager',
        name: 'FileManager',
        component: (resolve) => require(['./views/applications/filemanager/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/web-shell',
        name: 'WebShell',
        component: (resolve) => require(['./views/applications/shell/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/ftp-server',
        name: 'ftp',
        component: (resolve) => require(['./views/applications/ftp/FtpServer.vue'], resolve)
      },
      {
        path: '/applications/:appId/sql-config',
        name: 'SqlConfig',
        component: (resolve) => require(['./views/applications/sqlCfg/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/php-admin',
        name: 'phpAdmin',
        component: (resolve) => require(['./views/applications/phpAdmin/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/kibana',
        name: 'KBanner',
        component: (resolve) => require(['./views/applications/kibana/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/domainSSL',
        name: 'DomainSSL',
        component: (resolve) => require(['./views/applications/domainSSL/DomainSSL.vue'], resolve)
      },
      {
        path: '/applications/:appId/dbuser',
        name: 'Databases & Users',
        component: (resolve) => require(['./views/applications/dbUser/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/activities',
        name: 'Activities',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      },
      {
        path: '/applications/:appId/events',
        name: 'Events',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      },
      {
        path: '/applications/:appId/snapshots',
        name: 'Snapshots',
        component: (resolve) => require(['./views/applications/Snapshots.vue'], resolve)
      },
      {
        path: '/applications/:appId/metrics',
        name: 'Metrics',
        component: (resolve) => require(['./views/applications/metrics/index.vue'], resolve)
      },
      {
        path: '/applications/:appId/security',
        name: 'Security',
        component: (resolve) => require(['./views/applications/security/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/k8s-servers',
    name: 'K8S',
    meta: {
      title: 'menu.k8s[0]',
      i18n_text: 'menu.k8s[0]',
      permission: ['menu.k8s']
    },
    component: (resolve) => require(['./views/custom/K8s.vue'], resolve)
  },
  {
    path: '/k8s-servers/ordering',
    name: 'K8s Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.k8s[0]',
      permission: ['menu.products.k8s'],
      productLine: 'k8s'
    },
    component: (resolve) => require(['./views/custom/Ordering.vue'], resolve)
  },
  {
    path: '/gpu-servers',
    name: 'GPU',
    meta: {
      title: 'menu.gpu[0]',
      i18n_text: 'menu.gpu[0]',
      permission: ['menu.gpu']
    },
    component: (resolve) => require(['./views/gpu/GPUServers.vue'], resolve)
  },
  // 与部署列表平级，未登录可浏览下单页
  {
    path: '/gpu-servers/ordering',
    name: 'GPU Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.gpu[0]',
      permission: ['menu.products.gpu'],
      planCategory: 'GPU',
      productType: 'gpu',
      productLine: 'gpu',
      planTitleKey: 'menu.gpu[0]'
    },
    component: (resolve) => require(['./views/ordering/PlanOrdering.vue'], resolve)
  },
  {
    path: '/k8s-servers/:appId',
    name: 'K8s Server',
    meta: {
      permission: ['menu.k8s']
    },
    redirect: '/k8s-servers/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/k8s-servers/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/k8s-servers/:appId/service-info',
        name: 'ServiceInfo',
        component: (resolve) => require(['./views/applications/serviceInfo/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/gpu-servers/:appId',
    name: 'GPU Server',
    meta: {
      permission: ['menu.gpu']
    },
    redirect: '/gpu-servers/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/gpu-servers/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/gpu-servers/:appId/server-manage',
        name: 'ServerManagement',
        component: (resolve) => require(['./views/applications/servermanage/index.vue'], resolve)
      },
      {
        path: '/gpu-servers/:appId/additional-software',
        name: 'AdditionalSoftware',
        component: (resolve) =>
          require(['./views/applications/additionalSoftware/index.vue'], resolve)
      },
      {
        path: '/myvps/:appId/additional-software',
        name: 'AdditionalSoftware',
        component: (resolve) =>
          require(['./views/applications/additionalSoftware/index.vue'], resolve)
      },
      {
        path: '/gpu-servers/:appId/service-info',
        name: 'ServiceInfo',
        component: (resolve) => require(['./views/applications/serviceInfo/index.vue'], resolve)
      },
      {
        path: '/gpu-servers/:appId/events',
        name: 'Events',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      }
    ]
  },
  {
    path: '/dedicated-servers',
    name: 'Bare Metal',
    meta: {
      title: 'menu.dedicated[1]',
      i18n_text: 'menu.dedicated[0]',
      permission: ['menu.dedicated']
    },
    component: (resolve) => require(['./views/bareMetal/DedicatedServers.vue'], resolve)
  },
  // 与部署列表平级，未登录可浏览下单页
  {
    path: '/dedicated-servers/ordering',
    name: 'Dedicated Ordering',
    meta: {
      title: 'menu.ordering[0]',
      i18n_text: 'menu.products.dedicated[0]',
      permission: ['menu.products.dedicated'],
      planCategory: 'BareMetal',
      planType: 'Bare Metal',
      productType: 'baremetal',
      productLine: 'dedicated',
      planTitleKey: 'menu.dedicated[0]'
    },
    component: (resolve) => require(['./views/ordering/PlanOrdering.vue'], resolve)
  },
  {
    path: '/dedicated-servers/:appId',
    name: 'Bare Metal Server',
    meta: {
      permission: ['menu.dedicated']
    },
    redirect: '/dedicated-servers/:appId/overview',
    component: (resolve) => require(['./views/applications/ApplicationDetail.vue'], resolve),
    children: [
      {
        path: '/dedicated-servers/:appId/overview',
        name: 'Overview',
        component: (resolve) => require(['./views/applications/overview/index.vue'], resolve)
      },
      {
        path: '/dedicated-servers/:appId/server-manage',
        name: 'ServerManagement',
        component: (resolve) => require(['./views/applications/servermanage/index.vue'], resolve)
      },
      {
        path: '/dedicated-servers/:appId/additional-software',
        name: 'AdditionalSoftware',
        component: (resolve) =>
          require(['./views/applications/additionalSoftware/index.vue'], resolve)
      },
      {
        path: '/dedicated-servers/:appId/service-info',
        name: 'ServiceInfo',
        component: (resolve) => require(['./views/applications/serviceInfo/index.vue'], resolve)
      },
      {
        path: '/dedicated-servers/:appId/events',
        name: 'Events',
        component: (resolve) => require(['./views/applications/Activities.vue'], resolve)
      }
    ]
  },
  {
    path: '/billing',
    name: 'Billing',
    meta: {
      title: 'menu.billing[1]'
    },
    redirect: () => {
      return getPermission(['account.information.type.simple'])
        ? '/billing/invoices'
        : '/billing/billing-info'
    },
    component: (resolve) => require(['./views/billing/BillingDetail.vue'], resolve),
    children: [
      {
        path: '/billing/paymentmethod',
        name: 'Payment Method',
        redirect: '/billing/paymentmethod/credit-card',
        meta: {
          permission: ['menu.billing.payment']
        },
        // redirect: '/billing/paymentmethod/credit-card',
        component: (resolve) => require(['./views/billing/payment/PaymentMethod.vue'], resolve),
        children: [
          {
            path: '/billing/paymentmethod/:method',
            name: 'Method'
          }
        ]
      },
      {
        path: '/billing/invoices',
        name: 'Invoices',
        component: (resolve) => require(['./views/billing/invoices/Invoices.vue'], resolve)
      },
      {
        path: '/billing/credits',
        name: 'Credits',
        component: (resolve) => require(['./views/billing/credits/Credits.vue'], resolve)
      },
      {
        path: '/billing/recharge',
        name: 'Recharge Credits',
        component: (resolve) => require(['./views/billing/Recharge.vue'], resolve)
      }
    ]
  },
  {
    path: '/account',
    name: 'Account Information',
    meta: {
      title: 'menu.account[0]'
    },
    component: (resolve) => require(['./views/accountInfo/index.vue'], resolve),
    children: [
      {
        path: '/account/information',
        name: 'menu.account[1]',
        meta: {
          title: 'menu.account[1]',
          i18n_text: 'menu.account[1]'
        },
        component: (resolve) =>
          require(['./views/accountInfo/information/Information.vue'], resolve)
      },
      {
        path: '/account/verify-info',
        name: 'menu.account_vertifiy[0]',
        meta: {
          title: 'menu.account_vertifiy[0]',
          i18n_text: 'menu.account_vertifiy[0]'
        },
        component: (resolve) => require(['./views/accountInfo/verifyInfo/Verify.vue'], resolve)
      },
      {
        path: '/account/password',
        name: 'menu.password[0]',
        meta: {
          title: 'menu.password[0]',
          i18n_text: 'menu.password[0]'
        },
        component: (resolve) =>
          require(['./views/accountInfo/changePassword/ChangePassword.vue'], resolve)
      },
      {
        path: '/account/notification',
        name: 'menu.notification[0]',
        meta: {
          title: 'menu.notification[0]',
          i18n_text: 'menu.notification[0]'
        },
        component: (resolve) => require(['./views/accountInfo/notification/index.vue'], resolve)
      },
      {
        path: '/account/upgrade',
        name: 'Upgrade',
        meta: {
          title: 'menu.account_upgrade[0]'
        },
        component: (resolve) => require(['./views/accountInfo/upgrade/index.vue'], resolve)
      }
    ]
  },
  // {
  //   path: '/membership',
  //   name: 'Membership',
  //   meta: {
  //     title: 'menu.membership[0]',
  //     permission: ['account.membership']
  //   },
  //   component: (resolve) => require(['./views/membership/index.vue'], resolve)
  // },
  {
    path: '/check/:product/:plan_uuid',
    name: 'Check Out',
    meta: {
      title: 'menu.check[0]'
    },
    component: (resolve) => require(['./views/check/index.vue'], resolve)
  },
  {
    path: '/out-of-stock',
    name: 'Out of Stock',
    meta: {
      title: 'button.out_of_stock'
    },
    component: (resolve) => require(['./views/check/OutOfStock.vue'], resolve)
  },
  {
    path: '/invoice-detail/:invoiceId',
    name: 'Invoice Detail',
    meta: {
      title: 'menu.invoice_detail[0]'
    },
    component: (resolve) => require(['./views/invoice/index.vue'], resolve)
  },
  {
    path: '/order-confirm/:confirmId',
    name: 'Order Confirm',
    // 历史链接携带的是 package UUID，不能直接用作新流程的 invoice UUID。
    redirect: '/billing/invoices'
  },
  // 全产品公共对比页：未登录可访问，不挂产品 permission
  {
    path: '/compare',
    name: 'Plan Compare',
    meta: {
      title: 'ordering_table.comparison_title',
      i18n_text: 'ordering_table.comparison_title'
    },
    component: (resolve) => require(['./views/ordering/Compare.vue'], resolve)
  }
]

const getRouters = function (routes) {
  return routes.reduce((per, current) => {
    if (current.meta && current.meta.permission) {
      if (getPermission(current.meta.permission)) {
        per.push(current)
      }
    } else {
      per.push(current)
    }
    if (current.children) {
      current.children = getRouters(current.children)
    }
    return per
  }, [])
}

const router = new Router({
  mode: 'history',
  routes: getRouters(routers)
})

router.afterEach((to, from) => {
  // 只有 SSO 直接返回 Checkout 才保留登录暂存，站内重新进入视为新购买。
  if (to.name !== 'Check Out' || from.matched.length) {
    window.sessionStorage.removeItem('checkout_login')
  }
})

export default router
